import React, {Component, PureComponent} from 'react';
import './PerformanceChange.style.scss';
import ic from 'assets/icons/table-rows.svg';
import {
  Bar,
  ComposedChart,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

export default class PerformanceChange extends Component {
  render() {
    const data = [
      {
        year: '2021',
        TOI: 30,
        OPEX: 60,
        CIR: 60,
      },
      {
        year: '2022',
        TOI: 50,
        OPEX: 100,
        CIR: 20,
      },
    ];
    return (
      <div className='performance-container'>
        <h1 className='title'>
          <img src={ic} alt='' style={{marginRight: 8}} />
          PERFORMANCE CHANGE
        </h1>
        <ResponsiveContainer width='100%' height={300}>
          <ComposedChart height={300} data={data}>
            <XAxis dataKey='year' axisLine={false} tickLine={false} tick={<CustomizedAxisTick />} />
            <YAxis hide />

            <Bar dataKey='TOI' barSize={50} fill='#FBC83A' radius={8} />
            <Bar dataKey='OPEX' barSize={50} fill='#EBEBEB' radius={8} />
            <Line dataKey='CIR' stroke='#30AD65' strokeWidth={2} />
            <Legend
              wrapperStyle={{
                paddingTop: '20px',
              }}
            />
           <Tooltip cursor={false} content={<CustomTooltip />} />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    );
  }
}

class CustomizedAxisTick extends PureComponent {
  render() {
    const {x, y, payload} = this.props;

    return (
      <text x={x} y={y} dy={24} fill='#0B0B0A' textAnchor='middle' fontSize={14}>
        <tspan>{payload.value}</tspan>
      </text>
    );
  }
}
const CustomTooltip = (props) => {
  const {active, payload} = props;

  if (active && payload && payload.length) {
    const item = payload[0].payload;

    return (
      <div className='custom-tooltip'>
        <div className='name'>{item.year}</div>
        <div className='item'>
          <div className='color' style={{backgroundColor: '#FBC83A'}} />
          <div className='desc'>{item.TOI}</div>
        </div>
        <div className='item'>
          <div className='color' style={{backgroundColor: '#EBEBEB'}} />
          <div className='desc'>{item.OPEX}</div>
        </div>
        <div className='item'>
          <div className='color' style={{backgroundColor: '#30AD65'}} />
          <div className='desc'>{item.CIR}</div>
        </div>
      </div>
    );
  }

  return null;
};



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/OverviewWholeBank/components/PerformanceChange/PerformanceChange.js